import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PageLayout from '../../../components/layout/PageLayout';
import DataTable from '../../../components/ui/DataTable';
import ActionIconButton from '../../../components/ui/ActionIconButton';
import { notify } from '../../../components/feedback/notify';
import { MascaraCpf } from "../../../utils/MascaraCpf";
import { MascaraTelefone } from "../../../utils/MascaraTelefone";
import { MascaraCnpj } from "../../../utils/MascaraCnpj";
import AdicionarAdmin from "./AdicionarAdmin";

function Admins() {

    const token = localStorage.getItem('token');
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);
    const [adicionarAdmin, setAdicionarAdmin] = useState(false);

    const getUsuarios = useCallback(async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarAdmins`, {
                headers: {
                    Authorization: token
                }
            })
            setUsuarios(response.data.usuarios || []);
        } catch (error) {
            console.error("Erro ao listar admins:", error);
            notify.error("Não foi possível carregar a lista de administradores.");
        } finally {
            setLoading(false);
        }
    }, [token]);

    useEffect(() => {
        getUsuarios();
    }, [getUsuarios])

    const columns = [
        { key: 'idUsuario', label: 'ID', width: 72 },
        { key: 'Nome', label: 'Nome', sx: { fontWeight: 500 }, render: (u) => u?.Nome || '—' },
        { key: 'Email', label: 'E-mail', render: (u) => u?.Email || '—' },
        { key: 'Cpf', label: 'CPF', render: (u) => MascaraCpf(u?.Cpf) || '—' },
        { key: 'Cnpj', label: 'CNPJ', render: (u) => MascaraCnpj(u?.Cnpj) || '—' },
        { key: 'RazaoSocial', label: 'Razão Social', render: (u) => u?.RazaoSocial || '—' },
        { key: 'Telefone', label: 'Telefone', render: (u) => MascaraTelefone(u?.Telefone) || '—' },
        { key: 'acoes', label: 'Ações', align: 'right', width: 80, render: () => <ActionIconButton title="Editar" icon={<EditOutlinedIcon fontSize="small" />} pending /> },
    ];

    return (
        <PageLayout
            title="Administradores"
            subtitle="Pessoas da equipe com acesso a este painel."
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Usuários', to: '/usuarios' }, { label: 'Administradores' }]}
            actions={
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => setAdicionarAdmin(true)}>
                    Adicionar admin
                </Button>
            }
        >
            <DataTable
                columns={columns}
                rows={usuarios}
                getRowKey={(u, i) => u?.idUsuario ?? i}
                loading={loading}
                emptyMessage="Nenhum administrador cadastrado."
            />
            <AdicionarAdmin adicionarAdmin={adicionarAdmin} setAdicionarAdmin={setAdicionarAdmin} onSaved={getUsuarios} />
        </PageLayout>
    );
}

export default Admins;
